export default __webpack_public_path__ + "static/media/2_0124.9c7f23c1.webp";